<template>
  <VRow>
    <VCol class="text-center">
      <h2 class="mt-6" data-testid="error-message-500">
        {{ $t('error.title.500') }}
      </h2>
      <div class="font20">
        <span class="d-block">{{ $t('error.p.500errorLine1') }}</span>
        <span class="d-block">{{ $t('error.p.500errorLine2') }}</span>
      </div>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>

const i18n = useI18n()

useSeoMeta({
  title: i18n.t('error.title.500')
})
</script>

<style lang="scss" scoped>
</style>
